module.exports = __webpack_public_path__ + "img/hyeonwoo.012f84ac.png";